/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { RecipeType } from '../../../data/recipes.model';
import { ThumbnailFigure } from '../../atoms/ThumbnailFigure';
import Block from '../../atoms/layout/Block';
import { withI18N } from '../../hoc/withI18N';
import { FavoriteRecipeIcon } from '../recipes/FavoriteRecipeIcon';
import { toggleFavoriteRecipe } from '../../../actions/recipes';
import { Label } from '../../atoms/bootstrap/Label';
import { useDispatch } from 'react-redux';
import { GA4PageType } from '../../../analytics/ga4/types/page';
function RecipeGridCard({ item, translate, isFavorite, isCarousel }) {
    const dispatch = useDispatch();
    const toggleFavoriteIcon = useCallback(
        () => dispatch(toggleFavoriteRecipe({ id: item.id, url: item.link })),
        [item, dispatch]
    );
    const [googleData, setGoogleData] = useState();

    useEffect(() => {
        const data = {
            recipe_name: item.title,
            website_section: GA4PageType.allRecipes,
        };
        setGoogleData(data);
    }, [item]);

    return (
        <Block
            className={`finder-card col-xs-12 ${
                isCarousel ? 'col-sm-12' : 'col-sm-6 col-md-4 col-lg-3'
            } p-flex p-flex-column`}
        >
            <div className="thumbnail thumbnail--recipe">
                <ThumbnailFigure
                    link={item.link}
                    image={item.image}
                    altText={item.referenceTitle || item.title}
                    position={item.fileReferencePosition}
                >
                    {item.hasVideoTag && (
                        <Label classes="videoTag">{translate('Video')}</Label>
                    )}
                    <FavoriteRecipeIcon
                        active={isFavorite}
                        googleData={googleData}
                        toggle={toggleFavoriteIcon}
                    />
                </ThumbnailFigure>
                <div className="caption card">
                    <h3 className="p-margin-top-sm p-margin-bottom-sm">
                        <a href={item.link} className="p-color-black">
                            {item.referenceTitle || item.title}
                        </a>
                    </h3>
                </div>
                <div className="caption p-flex p-flex-align-center p-justify-space-between small finder-link">
                    <p className="finder-link__text">
                        <a href={item.link} className="finder-link__link">
                            {translate('Read more')}
                        </a>
                    </p>
                </div>
            </div>
        </Block>
    );
}

RecipeGridCard.propTypes = {
    item: PropTypes.shape(RecipeType),
    translate: PropTypes.func,
    isFavorite: PropTypes.bool,
    toggleFavoriteRecipe: PropTypes.func,
};

RecipeGridCard.defaultProps = {
    allowedTags: [],
};

export default withI18N(RecipeGridCard);
